<template>
  <div class="main-container">
    <page-header>{{ '已提交摘要' | dealLanguage('My Abstracts') }}</page-header>
    <div class="warp">
      <div class="contribution-list" v-if="list.length">
        <div class="contribution-card" v-for="item in list" :key="item.id">
          <div class="card-top">
            <div class="card-title">{{ item.title | empty }}</div>
            <div :class="['status-tag', statusClass(item.status)]">
              {{ statusText(item.status) }}
            </div>
          </div>
          <div class="card-content">
            <div class="card-info">
              <div class="info-row">
                <i class="iconfont">&#xe70a;</i>
                <span>{{ item.compName | empty }}</span>
              </div>
              <div class="info-row">
                <i class="iconfont">&#xe709;</i>
                <span>{{ item.author | empty }}</span>
              </div>
            </div>
            <img
              :src="static_img_url + 'pic/logo.png?v=' + $store.state.imgVersion"
              class="card-logo"
            />
          </div>
          <div class="card-bottom">
            <div class="submit-time" v-if="item.status == 1">
              {{ '提交时间' | dealLanguage('Submitted at') }}:
              {{ displayTime(item) | time_moment('YYYY-MM-DD HH:mm:ss') }}
            </div>
            <div v-else style="color: #C8161D;">未提交</div>
            <div class="actions">
              <Button type="primary" @click="handleEdit(item)">{{ '再次编辑' | dealLanguage('Edit Again') }}</Button>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-warpper" v-if="loading">
        <van-loading size="20px">{{ '加载中' | dealLanguage('Loading') }}...</van-loading>
      </div>
      <nothing v-if="!loading && list.length == 0">
        <router-link :to="{ name: 'abstractForm' }" class="btn">{{
          '去提交摘要' | dealLanguage('Submit Abstract')
        }}</router-link>
      </nothing>
      <div ref="indexlist-bottom"></div>
    </div>
  </div>
</template>
<script>
import Nothing from '@/components/common/nothing.vue'
import PageHeader from '@/components/mobile/pageHeader.vue'
import { getContributionList } from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'

export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('已提交摘要', 'My Abstracts'),
    }
  },
  inject: ['wxShare'],
  components: {
    PageHeader,
    Nothing,
  },
  created() {
    if (!this.user_key) return
    this.fetchList()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('已提交摘要-CSGCT', 'My Abstracts-CSGCT'),
      linkurl: this.vbef_path + '/contributionList',
    })
    if (!this.user_key) {
      this.$router.push({ name: 'index' })
      this.$notify(filter.dealLanguage('请先登录', 'Please log in first'))
      return
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      page: 1,
      size: 10,
      count: 0,
      list: [],
      loading: false,
      isMore: false,
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
    }),
  },
  methods: {
    statusText(status) {
      return String(status) === '1'
        ? filter.dealLanguage('已提交', 'Submitted')
        : filter.dealLanguage('草稿', 'Draft')
    },
    statusClass(status) {
      return String(status) === '1' ? 'submitted' : 'draft'
    },
    displayTime(item) {
      return item.submitTime || item.updateTime || item.createTime || ''
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      const listbox = this.$refs['indexlist-bottom']
      if (!listbox) return
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop
      if (scrollTop + windowHeight >= listabsoluteTop && scrollTop > 0 && !this.loading && this.isMore) {
        this.page++
        this.fetchList()
      }
    },
    async fetchList() {
      this.loading = true
      let res = await getContributionList({
        getCount: true,
        page: this.page,
        size: this.size,
      })
      this.loading = false
      if (res.code == 0) {
        const data = res.data || {}
        const contributions = data.contributions || []
        this.list = [...this.list, ...contributions]
        this.count = data.count || 0
        this.isMore = this.list.length < this.count
      } else {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleEdit(item) {
      this.$router.push({
        name: 'abstractForm',
        query: {
          id: item.id,
        },
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'

.warp
  padding 0.4rem

.contribution-list
  display flex
  flex-direction column
  gap 0.24rem

.contribution-card
  border 1px solid #E8E8E8
  border-radius 0.2rem
  padding 0.32rem
  background #FFFFFF

.card-top
  display flex
  align-items flex-start
  justify-content space-between
  gap 0.2rem

.card-title
  flex 1
  font-weight 700
  font-size 0.34rem
  color #1F2937
  line-height 0.5rem
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
  overflow hidden

.status-tag
  flex-shrink 0
  padding 0.04rem 0.16rem
  border-radius 999px
  font-size 0.22rem
  line-height 0.34rem
  &.submitted
    color #08C161
    background #EAFBF2
  &.draft
    color #FF9700
    background #FFF4E5

.card-content
  margin-top 0.24rem
  display flex
  align-items flex-end
  justify-content space-between
  gap 0.24rem
  .card-logo
    width 1.6rem
    height auto

.card-info
  flex 1
  .info-row
    display flex
    align-items center
    font-size 0.24rem
    color #333333
    line-height 0.36rem
    & + .info-row
      margin-top 0.12rem
    .iconfont
      margin-right 0.12rem
      color #333333

.card-bottom
  margin-top 0.24rem
  display flex
  align-items flex-end
  justify-content space-between
  gap 0.2rem

.submit-time
  font-size 0.22rem
  color #999999
  line-height 0.32rem

.actions
  display flex
  gap 0.2rem
  .van-button, .ivu-btn-primary
    color #fff
    background-color #C8161D
    border-color #C8161D
    width 1.8rem
    height 0.64rem
    border-radius 0.08rem
    font-size 0.24rem

</style>
